import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  ogImage, 
  twitterImage, 
  noIndex = false,
  canonicalUrl 
}) => {
  const location = useLocation();
  const baseUrl = 'https://namvoro.com';
  const currentUrl = `${baseUrl}${location.pathname}`;
  
  const defaultTitle = 'Namvoro - Enterprise Digital Brand Management';
  const defaultDescription = 'Protect your digital brand with enterprise-grade domain management, DNS solutions, and cybersecurity. Trusted by Fortune 500 companies.';
  const defaultKeywords = 'digital brand management, enterprise DNS, domain security, cybersecurity, email protection, brand protection, corporate domain management';
  const defaultOgImage = 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/namvoro-og-image.jpg';
  const defaultTwitterImage = 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/namvoro-twitter-card.jpg';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title || defaultTitle}</title>
      <meta name="title" content={title || defaultTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl || currentUrl} />
      
      {/* Robots */}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:site_name" content="Namvoro" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={twitterImage || defaultTwitterImage} />
      <meta property="twitter:site" content="@namvoro" />
    </Helmet>
  );
};

export default SEOHead;